<template>
  <section>
    <div v-if="loadingStatus">
      <ContentLoader :size="4" :type="'post'"></ContentLoader>
    </div>
    <div v-else>
      <div
        class="grid gap-8 xl:gap-6 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 grid-cols-1"
        v-if="data"
      >
        <div v-for="(d, i) in data" :key="i">
          <router-link
            :to="{
              name: 'UserTrainerPostView',
              params: { trainer_id: d.trainer_id, id: d.id },
            }"
          >
            <div
              class="px-4 py-3 shadow-lg rounded-lg h-64 flex flex-col ring-1 ring-gray-400"
            >
              <div class="flex items-center">
                <div class="flex-shrink-0">
                  <Avatar
                    :classStr="'h-8 w-8 mr-2'"
                    :src="baseUrlSrc(d.thumbnail_url)"
                  />
                </div>
                <div class="w-4/5">
                  <div
                    class="text-sm capitalize text-gray-dark font-medium text-ellipses"
                  >
                    {{ d.name }}
                  </div>
                  <p class="text-xs -mt-1 text-gray-light text-ellipses">
                    {{ handleCreatedAt(d.created_at) }}
                  </p>
                </div>
              </div>
              <div class="mt-4">
                <p
                  class="text-gray-light text-xs vertical-ellipses vertical-ellipses-lines break-all"
                >
                  {{ d.body }}
                </p>
              </div>
              <div class="flex flex-1 items-end mt-4">
                <div class="flex items-center">
                  <button
                    v-if="d.is_liked"
                    @click.prevent="handlePostLike(d.id, false)"
                  >
                    <HeartFill />
                  </button>

                  <button v-else @click.prevent="handlePostLike(d.id, true)">
                    <Heart />
                  </button>
                  <p class="text-xs ml-1">
                    <span class="text-gray-dark font-medium">{{
                      d.like_counter
                    }}</span
                    ><span class="text-gray-light"> Likes</span>
                  </p>
                </div>
                <div class="flex items-center ml-3">
                  <Chat />
                  <p class="text-xs ml-1">
                    <span class="text-gray-dark font-medium">{{
                      d.total_comments
                    }}</span
                    ><span class="text-gray-light"> Comments</span>
                  </p>
                </div>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>

    <div v-if="statusCode == 404">
      <p>No data found.</p>
    </div>
  </section>
</template>

<script>
import ContentLoader from "@/components/vue-spinner/ContentLoader";
import { Avatar } from "@/components/t-components";
import { Heart, Chat, HeartFill } from "@/components/icons";

export default {
  components: { Avatar, Chat, Heart, HeartFill, ContentLoader },
  props: {
    data: Array,
    handlePostLike: Function,
    statusCode: {
      type: Number,
    },
  },
  data() {
    return {};
  },
  computed: {
    loadingStatus() {
      return this.$store.getters.loadingStatus;
    },
  },
};
</script>
<style scoped>
/* .text-ellipses {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
} */
.vertical-ellipses {
  white-space: nowrap;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
}
.vertical-ellipses-lines {
  -webkit-line-clamp: 8;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  white-space: normal;
}
</style>
